import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCreateModel } from '../../../api/routes/models'
import { Button } from '../../../components/ui/button'
import { toast } from 'react-toastify'
import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

const RegisterModelRoute = () => {
    const [name, setName] = useState('')
    const navigate = useNavigate()
    const createModel = useCreateModel()

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()

        if (!name.trim()) {
            toast.error('Model name is required')
            return
        }

        createModel.mutate(
            { name: name.trim() },
            {
                onSuccess: () => {
                    toast.success('Model registered successfully')
                    navigate('/models')
                },
                onError: (error: any) => {
                    toast.error(
                        error?.response?.data?.message ||
                            error.message ||
                            'Failed to register model'
                    )
                },
            }
        )
    }

    return (
        <div className="mx-auto py-6 lg:py-10 px-4 sm:px-6 lg:px-8 xl:px-32">
            <div>
                <div className="mb-6">
                    <Link
                        to="/models"
                        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-4"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back to Models
                    </Link>
                    <h1 className="text-2xl font-semibold tracking-tight text-foreground">
                        Register Model
                    </h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        Create a new device model in the system.
                    </p>
                </div>

                <div className="rounded-lg border bg-card p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-1.5">
                            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                                Model Name
                            </label>
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                placeholder="Enter model name"
                                className="h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-1 focus:ring-ring"
                            />
                        </div>
                        <div className="flex justify-end gap-2 pt-2">
                            <Button
                                type="button"
                                variant="outline"
                                onClick={() => navigate('/models')}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={createModel.isPending}
                            >
                                {createModel.isPending
                                    ? 'Registering...'
                                    : 'Register Model'}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export { RegisterModelRoute }
